import { IoCheckmarkCircleOutline } from 'react-icons/io5';
import { BiCoinStack } from 'react-icons/bi';
import { IoLockClosedOutline } from 'react-icons/io5';
import { BiLike } from 'react-icons/bi';
import img1 from '../../../../assets/img/Services/OperationalExe/cicd.jpg'

import { AiOutlineSolution } from "react-icons/ai";
import { MdOutlineIntegrationInstructions } from "react-icons/md";
import { AiOutlineAppstore } from "react-icons/ai";

export default function MainSection1() {
  return ( 
    <div className="container mx-auto px-4 py-12 md:py-12 md:px-10">
      <div className="flex flex-col mb-6 justify-center lg:justify-center lg:flex-row md:mb-8">
          <h2 className="max-w-lg mb-5 font-sans text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl sm:leading-none md:mb-6 group">
            <span className="inline-block mb-1 sm:mb-4">Our Offerings</span>
            <div className="h-1 ml-auto duration-300 origin-left transform bg-primary scale-x-30 group-hover:scale-x-100" />
          </h2>
         
        </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
        <div className="space-y-8">
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-bold leading-tight text-gray-900">
              CI/CD Pipeline Implementation
            </h1>
            <p className="text-lg text-gray-600">
              Automate your software delivery with a robust CI/CD pipeline.
              Utilize tools like Jenkins, GitLab CI, Azure DevOps, and AWS
              CodePipeline to streamline development, testing, and deployment
              processes. Enhance collaboration, ensure quality, and accelerate
              time-to-market with seamless integration and automation.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-8">
            {/* Feature 1 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <IoCheckmarkCircleOutline className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Streamlined Automation
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Automate your software delivery process seamlessly with powerful
                CI/CD tools.
              </p>
            </div>

            {/* Feature 2 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineAppstore className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Diverse Tool Integration
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Leverage industry-leading platforms like Jenkins, GitLab CI,
                Azure DevOps, and AWS CodePipeline.
              </p>
            </div>

            {/* Feature 3 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <AiOutlineSolution className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Scalable Solutions
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Scale your CI/CD pipeline to meet the growing demands of your
                projects.
              </p>
            </div>

            {/* Feature 4 */}
            <div className="space-y-3">
              <div className="flex items-center space-x-2">
                <MdOutlineIntegrationInstructions className="w-6 h-6 text-indigo-600" />
                <h3 className="font-semibold text-gray-900">
                  Improved Collaboration
                </h3>
              </div>
              <p className="text-gray-600 text-sm">
                Enhance team productivity by integrating tools that support
                shared workflows and version control.
              </p>
            </div>
          </div>
        </div>

        <div className="relative h-[500px] rounded-3xl overflow-hidden">
          <img
            src={img1}
            alt="Workspace with laptop and plant"
            className="object-cover w-full h-full rounded-3xl"
          />
        </div>
      </div>
    </div>
  );
}
